"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var util_1 = require("../../util");

function ButtonBase(props) {
  var onClick = props.onClick,
      render = props.render,
      onLoadingChange = props.onLoadingChange,
      rest = __rest(props, ["onClick", "render", "onLoadingChange"]);

  var startLoading = function startLoading() {
    onLoadingChange && onLoadingChange(true);
  };

  var stopLoading = function stopLoading() {
    setTimeout(function () {
      onLoadingChange && onLoadingChange(false);
    });
  };

  var handleClick = function handleClick(event) {
    if (onClick) {
      var promise = onClick(event);

      if (util_1.isPromise(promise)) {
        startLoading();
        promise.then(function () {
          return stopLoading();
        }).catch(function (error) {
          stopLoading();
          throw new Error(error);
        });
      }
    }
  };

  return react_1.default.createElement(react_1.default.Fragment, null, render(__assign({}, rest, {
    onClick: handleClick
  })));
}

exports.ButtonBase = ButtonBase;
ButtonBase.defaultProps = {
  render: function render(_a) {
    var innerRef = _a.innerRef,
        rest = __rest(_a, ["innerRef"]);

    return react_1.default.createElement("button", __assign({
      ref: innerRef
    }, rest));
  }
};